import React from 'react';
import PropTypes from 'prop-types';

const NavArrowDown = ({ fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13.153" height="7.627" viewBox="0 0 13.153 7.627">
      <g id="Group_635" data-name="Group 635" transform="translate(-22 69.426) rotate(-90)">
        <path id="Path_185" data-name="Path 185" d="M7.627.881,6.771,0,0,6.576l6.771,6.577.856-.882-5.863-5.7Z" transform="translate(61.799 22)" fill={fill} />
      </g>
    </svg>
  )
}

NavArrowDown.defaultProps = {
  fill: '#000'
}

NavArrowDown.propTypes = {
  fill: PropTypes.string
}

export default NavArrowDown;
